module.exports = __webpack_public_path__ + "static/media/icon_pick_tour.215ed47f.svg";